module.exports = __webpack_public_path__ + "img/bjkjersey.e0881bc0.svg";